/** Ported from haulsheet index.html ocrPrep (browser canvas). */
export function ocrPrep(src: Blob | File | string): Promise<HTMLCanvasElement> {
  return new Promise((res, rej) => {
    let blobUrl = "";
    const img = new Image();
    img.onerror = () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
      rej(new Error("Could not open that picture."));
    };
    img.onload = () => {
      try {
        const w = img.naturalWidth;
        const h = img.naturalHeight;
        if (!w || !h) throw new Error("Could not open that picture.");
        const sc = Math.min(3, Math.max(1, 5600 / w), Math.sqrt(16e6 / (w * h)));
        const c = document.createElement("canvas");
        c.width = Math.max(1, Math.round(w * sc));
        c.height = Math.max(1, Math.round(h * sc));
        const ctx = c.getContext("2d", { willReadFrequently: true });
        if (!ctx) throw new Error("Could not open that picture.");
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, c.width, c.height);
        if (blobUrl) URL.revokeObjectURL(blobUrl);
        const d = ctx.getImageData(0, 0, c.width, c.height);
        const p = d.data;
        let sum = 0;
        let cnt = 0;
        for (let i = 0; i < p.length; i += 64) {
          sum += (p[i]! + p[i + 1]! + p[i + 2]!) / 3;
          cnt++;
        }
        const dark = sum / cnt < 110;
        for (let i = 0; i < p.length; i += 4) {
          const v = dark
            ? 255 - Math.max(p[i]!, p[i + 1]!, p[i + 2]!)
            : Math.min(p[i]!, p[i + 1]!, p[i + 2]!);
          p[i] = p[i + 1] = p[i + 2] = v;
          p[i + 3] = 255;
        }
        ctx.putImageData(d, 0, 0);
        res(c);
      } catch (e) {
        if (blobUrl) URL.revokeObjectURL(blobUrl);
        rej(e);
      }
    };
    if (typeof src === "string") img.src = src;
    else {
      blobUrl = URL.createObjectURL(src);
      img.src = blobUrl;
    }
  });
}
